import { useMemo } from 'react';
import { useTheme } from 'styled-components';

export const useBarchartStyling = () => {
  const theme = useTheme();

  const xAxisTickLabelProps = useMemo(
    () => ({
      fill: theme.palette.grey[600],
      fontSize: theme.typography.overline.fontSize,
      lineHeight: theme.typography.overline.lineHeight,
      fontFamily: theme.typography.overline.fontFamily,
      fontWeight: theme.typography.overline.fontWeight,
      textAnchor: 'middle' as 'middle',
    }),
    [
      theme.palette.grey,
      theme.typography.overline.fontFamily,
      theme.typography.overline.fontSize,
      theme.typography.overline.fontWeight,
      theme.typography.overline.lineHeight,
    ],
  );

  const yAxisTickLabelProps = useMemo(
    () => ({
      fill: theme.palette.grey[600],
      fontSize: theme.typography.overline.fontSize,
      lineHeight: theme.typography.overline.lineHeight,
      fontFamily: theme.typography.overline.fontFamily,
      fontWeight: theme.typography.overline.fontWeight,
      textAnchor: 'end' as 'end',
      dy: '0.4rem',
    }),
    [
      theme.palette.grey,
      theme.typography.overline.fontFamily,
      theme.typography.overline.fontSize,
      theme.typography.overline.fontWeight,
      theme.typography.overline.lineHeight,
    ],
  );

  return {
    yAxisTickLabelProps,
    yAxisStrokeColor: theme.palette.divider,
    xAxisTickLabelProps,
    xAxisStrokeColor: theme.palette.divider,
    cartesianColor: theme.palette.divider,
  };
};
